import React, {useEffect, useState} from 'react';
import axios from 'axios';
import "./UploadSingleFile.css"
import {useLocation} from "react-router-dom";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import {Button, TextField} from "@mui/material";
import {IoIosCloseCircle} from "react-icons/io";
import CustomAlert from "../ConfirmationModal/CustomAlert";
import DatePicker from "react-datepicker";
import {ka} from "date-fns/locale";
import {jwtDecode} from "jwt-decode";
import CaseNotificationEnum from "../../enums/CaseNotiFicationEnum";

const EditCertificateFile = ({onClose, onFileUpload, caseData, users, certificateFileData}) => {
    const [inspectionSertificatIssuingAgency, setInspectionSertificatIssuingAgency] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [sertificatReleaseDate, setSertificatReleaseDate] = useState(null);
    const [inspectionSertificatValidityPeriodDate, setInspectionSertificatValidityPeriodDate] = useState(null);
    const location = useLocation();
    const caseId = new URLSearchParams(location.search).get('id');
    const [caseFileNumber, setCaseFileNumber] = useState('');
    const [alert, setAlert] = useState({show: false, message: '', type: ''});
    const disableUpload = !inspectionSertificatIssuingAgency ||
        sertificatReleaseDate === null ||
        inspectionSertificatValidityPeriodDate === null ||
        caseFileNumber === ''
    const [roleId, setRoleId] = useState('');



    useEffect(() => {
        const token = localStorage.getItem("jwtToken");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setRoleId(decoded.role);
            } catch (error) {
                setRoleId("");
            }
        }
    }, []);

    const sendNotification = async (fileId) => {
        const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");
        const deputyHeadOfAgency = users.find(user => user.roleName === "DeputyHeadOfAgency");

        const caseNotification = {
            nextStepUserId: roleId === "HEADOFAGENCY" ? deputyHeadOfAgency.id : headOfAgency.id,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: fileId,
            action: CaseNotificationEnum.createdFile.id,
            caseStatus: 8,
            viewed: true,

        };

        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
    };



    useEffect(() => {
        function handleEscapeKey(event) {
            if (event.key === "Escape") {
                onClose();
            }
        }


        document.addEventListener('keydown', handleEscapeKey);

        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, [onClose]);


    const performUpload = async () => {

        const payload = {
            caseId: caseId,
            inspectionDocumentCheckingDate: caseData.inspectionDocumentCheckingDate,
            inspectionDocumentmplementation: caseData.inspectionDocumentmplementation,
            inspectionSertificatValidityPeriodDate: inspectionSertificatValidityPeriodDate ? inspectionSertificatValidityPeriodDate.toISOString() : null
        };
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateCaseSertificatAndInspectionInfo`, payload);
            if (!response.data.success) {
                return
            }
        } catch (error) {
            return
        }

        setIsUploading(true);
        const fileData = {
            ...certificateFileData,
            isSertificatFile: true,
            sertificatReleaseDate: sertificatReleaseDate ? sertificatReleaseDate.toISOString() : null,
            inspectionSertificatValidityPeriodDate: inspectionSertificatValidityPeriodDate ? inspectionSertificatValidityPeriodDate.toISOString() : null,
            inspectionSertificatIssuingAgency: inspectionSertificatIssuingAgency,
            caseFileNumber: caseFileNumber
        };

        try {
            const response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditCaseFile`, fileData);
            await sendNotification(response.data.resultId)
            setAlert({show: true, message: 'დოკუმენტი აიტვირთა წარმატებით!', type: 'success'});
        } catch (error) {
            setAlert({show: true, message: 'დაფიქსირდა შეცდომა, ცადეთ მოგივანევბით!', type: 'error'});
        } finally {
            setIsUploading(false);
            setIsModalOpen(false);
            onFileUpload();
            onClose();
        }
    };


    return (
        <div>
            <div className="upload-single-popup">
                <div className="upload-single-container">
                    <IoIosCloseCircle className="upload-single-close-icon" onClick={onClose}>Close</IoIosCloseCircle>
                    <div className="upload-single-header">
                        <p className="upload-single-title">ინსპექტირების სერტიფიკატის დოკუმენტის ატვირთვა</p>
                    </div>
                    <div className="upload-single-body">

                        <TextField
                            type="text"
                            fullWidth
                            label="დოკუმენტის ნომერი"
                            variant="outlined"
                            value={caseFileNumber}
                            onChange={(e) => setCaseFileNumber(e.target.value)}
                            InputProps={{inputProps: {min: 1}}}
                        />
                        <TextField
                            label="გამცემი ორგანო"
                            variant="outlined"
                            type="text"
                            value={inspectionSertificatIssuingAgency}
                            onChange={(e) => setInspectionSertificatIssuingAgency(e.target.value)}
                        />


                        <div className="full-width">
                            <p>გაცემის თარიღი:</p>
                            <DatePicker
                                selected={sertificatReleaseDate}
                                onChange={(date) => setSertificatReleaseDate(date)}
                                locale={ka}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                dateFormat="dd/MM/yyyy"
                                placeholderText="აირჩიეთ თარიღი"
                                className="full-width"
                            />
                        </div>

                        <div className="full-width">
                            <p>გადამოწმების თარიღი:</p>
                            <DatePicker
                                selected={inspectionSertificatValidityPeriodDate}
                                onChange={(date) => setInspectionSertificatValidityPeriodDate(date)}
                                locale={ka}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                dateFormat="dd/MM/yyyy"
                                minDate={new Date()}
                                placeholderText="აირჩიეთ თარიღი"
                                className="full-width"
                            />
                        </div>



                    </div>
                    <div className="upload-single-footer">
                        <Button style={{width: "100%"}} onClick={() => setIsModalOpen(true)}
                                disabled={disableUpload} variant="contained">
                            {isUploading ? 'ატვირთვა...' : 'დოკუმენტის ატვირთვა'}
                        </Button>
                    </div>
                </div>
                <ConfirmationModal
                    isOpen={isModalOpen}
                    onRequestClose={() => setIsModalOpen(false)}
                    onConfirm={performUpload}
                />

            </div>
            {alert.show &&
                <CustomAlert
                    message={alert.message}
                    type={alert.type}
                    onClose={() => setAlert({...alert, show: false})}
                />
            }
        </div>

    );
};

export default EditCertificateFile;
